import { TableColumnDef } from '../models/table-column.model';
import { TableRowValue } from '../models/table-row-value.model';
import { AbstractRow } from '../models/table-row.model';

export const getRowValue = (
  row: AbstractRow,
  column: TableColumnDef
): TableRowValue => {
  if (column['valueGetter']) {
    return column.valueGetter(row);
  } else {
    return row[column.field] as TableRowValue;
  }
};
